import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { withUrlGenerator } from '@folklore/react-app';
import { injectIntl } from 'react-intl';

import Header from '../partials/Header';
import Footer from '../partials/Footer';

import {
    setSize as setSizeActions,
    setStickyHeader as setStickyHeaderActions,
    setMobile as setMobileActions,
} from '../../actions/LayoutActions';

import styles from '../../../styles/layouts/main.scss';

const propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    stickyHeader: PropTypes.bool.isRequired,
    trailerVisible: PropTypes.bool.isRequired,
    mobile: PropTypes.bool.isRequired,
    intl: PropTypes.shape({
        locale: PropTypes.string,
    }).isRequired,
    // urlGenerator: PropTypes.shape({
    //     route: PropTypes.func,
    // }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
    contactPage: PropTypes.shape({
        handle: PropTypes.string,
    }).isRequired,
    page: PropTypes.shape({
        handle: PropTypes.string,
    }),
    headerMenuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    children: PropTypes.node.isRequired,
    setSize: PropTypes.func.isRequired,
    setStickyHeader: PropTypes.func.isRequired,
    setMobile: PropTypes.func.isRequired,
};

const defaultProps = {
    page: null,
};

class MainLayout extends Component {
    constructor(props) {
        super(props);

        this.onScroll = this.onScroll.bind(this);
        this.onResize = throttle(this.onResize, 50, {
            leading: false,
            trailing: true,
        }).bind(this);

        this.refHeader = null;
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
        this.updateSize();
        this.updateMobile();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
        const { stickyHeader } = this.props;
        const minScroll = 70;
        const doc = document.documentElement;
        const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (!stickyHeader && top > minScroll) {
            this.props.setStickyHeader(true);
        } else if (stickyHeader && top <= minScroll) {
            this.props.setStickyHeader(false);
        }
    }

    onResize() {
        this.updateSize();
        this.updateMobile();
        this.onScroll();
    }

    updateSize() {
        this.props.setSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    updateMobile() {
        // console.log('bro', window.innerWidth, window.innerWidth < 768);
        if (window.innerWidth < 768) {
            this.props.setMobile(true);
        } else {
            this.props.setMobile(false);
        }
    }

    render() {
        const {
            width,
            height,
            mobile,
            intl,
            contactPage,
            stickyHeader,
            trailerVisible,
            headerMenuItems,
            children,
            location,
            page,
            // urlGenerator,
        } = this.props;
        const { locale } = intl;
        return (
            <div
                className={classNames({
                    [styles.container]: true,
                    [styles.stickyHeader]: stickyHeader,
                })}
            >
                <div
                    className={classNames({
                        [styles.header]: true,
                        [styles.visible]: !trailerVisible,
                    })}
                    ref={(ref) => {
                        this.refHeader = ref;
                    }}
                >
                    <Header
                        sticky={stickyHeader}
                        dark={
                            !stickyHeader &&
                            (page === null ||
                                (page.handle !== 'home' && page.type !== 'production'))
                        }
                        menuItems={[
                            ...headerMenuItems.map(item => ({
                                ...item,
                                current: location.pathname === item.url,
                            })),
                            {
                                label: locale === 'fr' ? 'EN' : 'FR',
                                url: get(page, `urls.${locale === 'fr' ? 'en' : 'fr'}`, ''),
                                external: true,
                            },
                        ]}
                    />
                </div>
                <div className={styles.content}>
                    {React.cloneElement(children, {
                        width,
                        height,
                        mobile,
                    })}
                </div>
                <div className={styles.footer}>
                    <Footer contactLink={contactPage.url} />
                </div>
            </div>
        );
    }
}

MainLayout.propTypes = propTypes;
MainLayout.defaultProps = defaultProps;

const mapStateToProps = ({ site, layout }, { location }) => ({
    ...(layout.size || null),
    stickyHeader: layout.stickyHeader,
    trailerVisible: layout.trailerVisible,
    mobile: layout.mobile,
    headerMenuItems: site.headerMenuItems,
    contactPage: site.pages.find(it => it.handle === 'contact') || null,
    page:
        site.page !== null && site.page.url === location.pathname
            ? site.page
            : site.pages.find(it => it.url === location.pathname) ||
              (site.productions || []).find(it => it.url === location.pathname) ||
              (site.news || []).find(it => it.url === location.pathname) ||
              null,
});

const mapDispatchToProps = dispatch => ({
    setSize: size => dispatch(setSizeActions(size)),
    setStickyHeader: sticky => dispatch(setStickyHeaderActions(sticky)),
    setMobile: sticky => dispatch(setMobileActions(sticky)),
});

const WithStateContainer = connect(mapStateToProps, mapDispatchToProps)(MainLayout);
const WithRouterContainer = withRouter(WithStateContainer);
const WithUrlGeneratorContainer = withUrlGenerator()(WithRouterContainer);
export default injectIntl(WithUrlGeneratorContainer);



// WEBPACK FOOTER //
// ./js/components/layouts/Main.jsx